import { type ElementType, Fragment } from 'react'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@components/atoms/Breadcrumb'
import { SpriteUrlProvider } from '@components/utils/spriteUrl'

export type BreadcrumbEntry = { label: string; href: string }

type BreadcrumbsProps = {
  items: BreadcrumbEntry[]
  linkComponent?: ElementType<{ href: string }>
  spriteUrl?: string
}

export function Breadcrumbs({ items, linkComponent: LinkComponent = 'a', spriteUrl }: BreadcrumbsProps) {
  if (items.length < 2) return null

  const breadcrumb = (
    <Breadcrumb className="tw:flex tw:min-h-14 tw:items-center tw:border-b tw:border-gray-200 tw:px-6 tw:pr-20 tw:lg:pr-6">
      <BreadcrumbList>
        {items.map((item, index) => (
          <Fragment key={`${index}-${item.label}`}>
            <BreadcrumbItem>
              {index === items.length - 1 ? (
                <BreadcrumbPage>{item.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <LinkComponent href={item.href}>{item.label}</LinkComponent>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
            {index < items.length - 1 && <BreadcrumbSeparator />}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  )

  return spriteUrl ? <SpriteUrlProvider url={spriteUrl}>{breadcrumb}</SpriteUrlProvider> : breadcrumb
}
